<template>
  <div class="photos__wrapper">
    <div class="item__photos" ref="photos">
      <button
        v-if="galleryScrollLeft < (itemData.pictures.length - 2) * 300"
        class="item__arrow"
        @click="scrollGalleryRight">
        <i class="fal fa-chevron-right"/>
      </button>
      <button
        v-if="galleryScrollLeft > 0"
        class="item__arrow item__arrow--left"
        @click="scrollGalleryLeft">
        <i class="fal fa-chevron-left"/>
      </button>
      <div
        class="item__photosContainer"
        id="gallery"
        @scroll="onGalleryScroll">
        <div
          v-for="(photo, photoIndex) in itemData.pictures"
          :key="`photo_${photoIndex}`"
          @click="$store.commit('setOpenImageIndex', photoIndex)"
          class="item__photo">
          <v-lazy-image
            v-if="'packagedfood|freshfood|fashion|cosmetics|homeware|productoffering'.includes(itemData.item_type)"
            :src="imgix(photo, { width: 300, height: 300 })"
            :src-placeholder="imgix(photo, { width: 30, height: 30 })"
            width="300"
            height="300"
            style="object-fit: contain;"
          />
          <v-lazy-image
            v-else
            :src="imgix(photo, { width: 600, height: 600 })"
            :src-placeholder="imgix(photo, { width: 30, height: 30 })"
            width="300"
            height="300"
            style="object-fit: cover;"
          />
          <div class="item__loader">
            <vue-content-loading
              v-if="!photo"
              :height="300"
              :width="300"
              :key="`photoLoading_${photoIndex}`"
              preserveAspectRatio="xMinYMin">
              <rect x="0" y="0" rx="2" ry="2" width="100%" height="100%"/>
            </vue-content-loading>
          </div>
        </div>
      </div>
    </div>
    <div
      class="photo__preview"
      :class="{'hidescroll': itemData.pictures.length < 4}"
    >
      <div
        v-for="(photo, photoIndex) in itemData.pictures"
        :key="`photo_${photoIndex}`"
        @click="handleLocalImageSelection(photoIndex)"
        class="item__photo">
        <v-lazy-image
          v-if="'packagedfood|freshfood|fashion|cosmetics|homeware|productoffering'.includes(itemData.item_type)"
          :src="imgix(photo, { width: 75, height: 75 })"
          :src-placeholder="imgix(photo, { width: 30, height: 30 })"
          width="75"
          height="75"
          style="object-fit: contain;"
        />
        <v-lazy-image
          v-else
          :src="imgix(photo, { width: 75, height: 75 })"
          :src-placeholder="imgix(photo, { width: 30, height: 30 })"
          width="75"
          height="75"
          style="object-fit: cover;"
        />
        <div class="item__loader">
          <vue-content-loading
            v-if="!photo"
            :height="75"
            :width="75"
            :key="`photoLoading_${photoIndex}`"
            preserveAspectRatio="xMinYMin">
            <rect x="0" y="0" rx="2" ry="2" width="100%" height="100%"/>
          </vue-content-loading>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import imgix from '@/services/imgix'
import VueContentLoading from 'vue-content-loading'

export default {
  name: 'ImageGallery',
  components: {
    VueContentLoading
  },
  data () {
    return {
      galleryScrollLeft: 0,
      imgix
    }
  },
  props: {
    itemData: {
      type: Object,
      required: true,
      default: () => {}
    }
  },
  methods: {
    handleLocalImageSelection (index) {
      document.getElementById('gallery').scrollTo({
        left: (300 * index),
        behavior: 'smooth'
      })
    },
    scrollGalleryRight () {
      document.getElementById('gallery').scrollBy({
        left: 300,
        behavior: 'smooth'
      })
    },
    scrollGalleryLeft () {
      document.getElementById('gallery').scrollBy({
        left: -300,
        behavior: 'smooth'
      })
    },
    onGalleryScroll (event) {
      this.galleryScrollLeft = event.target.scrollLeft
    }
  }
}
</script>

<style scoped lang="stylus">
.photos__wrapper {
  display: flex;
  flex-direction: row-reverse;
  justify-content: flex-end;

  @media screen and (max-width: 960px) {
    flex-direction: column;
  }
}
.photo__preview {
  // width: 100%;
  // min-width: 750px;
  max-height: 300px;
  margin: 0 20px;
  overflow-y: scroll;
  display: flex;
  flex-direction: column;

  @media screen and (max-width: 960px) {
    flex-direction: row;
    margin 10px 0;
    overflow-x: scroll;
  }
}
.hidescroll {
  overflow: hidden;
}
.item
  width: 100%;
  max-width: 1040px;
  margin: 0 auto;
  padding: 0 10px;
  box-sizing border-box
  text-align left
  z-index 1
  &__photos
    position relative
    height 300px
    width 100%
    max-width: 300px;
    min-width: 300px;
    justify-content center
    overflow hidden
  &__arrow
    position absolute
    color black
    right 10px
    width 30px
    // color white
    font-size 34px
    top calc(50% - 25px)
    cursor pointer
    z-index 2
    background transparent
    border none
    &--left
      left 10px
  &__photosContainer
    width auto
    overflow-y hidden
    white-space nowrap
    height 330px
    display flex
    &__photo
    display inline-block
    position relative
    cursor pointer
    width 300px
    height 300px
    background-color white
    overflow hidden
    z-index 1
    img
      position absolute
      z-index 2
      margin 0 auto
</style>
